<template>
    <div class="msgbl-content" :style="bgColor">
      <slot />
    </div>
</template>

<script>
export default {
  name: 'MsgblContent',
  props: {
    type: {
        type: String,
        required: true
    }
  },
  computed: {
    bgColor() {
      const styles = {}
      switch (this.type) {
        case 'client_to_business':
          styles.backgroundColor = '#ffffff'
          break;
        case 'to_business':
          styles.backgroundColor = '#f3f3f3'
          break;
        case 'business_to_client':
          styles.backgroundColor = '#ffffff'
          break;
      }

      return styles
    }
  }
}
</script>

<style lang="scss" scoped>
.msgbl-content {
    border-radius: 3px;
    margin-top: 10px;
}
</style>